import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  MEDICAL_INSURANCE = "Medical Insurance",
  LOANS = "Loans",
  LIVING_ACCOMMODATION = "Living Accommodation",
  MEAL_ALLOWANCE = "Meal Allowance",
  EDUCATION = "Education",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
